import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-381a6803"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "address-search-container" }
const _hoisted_2 = { class: "contents" }
const _hoisted_3 = { class: "map-upper-btns" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode($setup["NavigationBar"], {
      title: "주소검색",
      shouldHideBackButton: true,
      onOnClickClose: $setup.emitOnClickClose
    }, {
      rightButton: _withCtx(() => [
        _createElementVNode("button", {
          class: _normalizeClass(["right-btn", { disabled: !$setup.isSelectedAddress }]),
          type: "button",
          onClick: _cache[0] || (_cache[0] = ($event: any) => ([$setup.emitOnClickApplyBtn(), $setup.emitOnClickClose()])),
          "aria-label": "선택한 주소 적용하기"
        }, " 적용 ", 2 /* CLASS */)
      ]),
      _: 1 /* STABLE */
    }),
    _createElementVNode("div", _hoisted_2, [
      _createVNode($setup["NaverMap"], {
        shouldShowPositionMarker: true,
        latitude: $setup.selectedAddress?.latitude,
        longitude: $setup.selectedAddress?.longitude,
        infoWindowContent: $setup.infoWindowContent,
        syncMarkerWithMapCenter: true,
        zoomLevel: $setup.zoomLevel,
        onClick: $setup.hideSearchResult,
        onOnUpdateAddress: $setup.updateAddressByMap
      }, null, 8 /* PROPS */, ["latitude", "longitude", "infoWindowContent", "zoomLevel"]),
      _createVNode($setup["AddressSearch"], {
        ref: "addressSearch",
        class: _normalizeClass({ 'has-results': $setup.hasSearchResults }),
        searchKeyword: $setup.searchKeyword,
        onOnChangedSearchKeyword: $setup.updateSearchKeyword,
        onOnSelectedAddress: $setup.selectAddress,
        onOnSearchResultsChanged: $setup.updateSearchResultsStatus
      }, null, 8 /* PROPS */, ["class", "searchKeyword"]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode($setup["MapZoomLevelSetter"], {
          class: "zoom-level",
          zoomLevel: $setup.zoomLevel,
          maxZoomLevel: $setup.MAX_ZOOM_LEVEL,
          minZoomLevel: $setup.MIN_ZOOM_LEVEL,
          onZoomIn: $setup.increaseZoomLevel,
          onZoomOut: $setup.decreaseZoomLevel
        }, null, 8 /* PROPS */, ["zoomLevel"])
      ])
    ])
  ]))
}